import { Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';

import { EsriMap } from '@lib/geo/esri';

import { BaseZoomManagementService } from '../base-zoom-management.service';

@Injectable({
  providedIn: 'root',
})
export class EsriZoomManagementService extends BaseZoomManagementService {
  private _map?: EsriMap;

  constructor() {
    super();
  }

  public setMap(map: EsriMap): void {
    this._map = map;
  }

  public setZoom(zoom: number): void {
    if (!this._map?.mapView) {
      return;
    }

    this._map.mapView.zoom = zoom;
  }

  public getZoom(): number {
    return this._map?.mapView?.zoom || this._map?.sceneView?.zoom || 0;
  }

  public zoomIn(): void {
    const currentZoom = this.getZoom();
    this.setZoom(currentZoom + 1);
  }

  public zoomOut(): void {
    const currentZoom = this.getZoom();
    this.setZoom(currentZoom - 1);
  }

  public async setZoomWithAnimation(zoom: number): Promise<void> {
    if (!this._map?.mapView) {
      return;
    }

    // Use a reasonable delay instead of checking private property
    await new Promise((resolve) => setTimeout(resolve, 100));

    await this._map.panTo({
      zoom,
    });
  }

  public getMaxZoomAtLatLng?(location: any): Observable<number> {
    // ESRI doesn't have a direct equivalent to Google's MaxZoomService
    // Return a reasonable default max zoom for ESRI
    console.warn('getMaxZoomAtLatLng not fully implemented for ESRI - see FWX-2761');
    return of(21); // Default max zoom for ESRI
  }
}
